<template>
  <div class="seatmap-container">
    <HeaderBar />
    <div class="seatmap-main">
      <div class="seatmap-side">
        <div v-for="row in leftRows" :key="'L'+row" class="seat-row">
          <button
            v-for="col in 6"
            :key="'L'+row+'-'+col"
            class="seat-btn"
            draggable="true"
            @dragstart="handleDragStart((row-1)*6+col-1)"
            @dragover.prevent
            @drop="handleDrop((row-1)*6+col-1)"
            :style="getStudent((row-1)*6+col-1).groupId ? { borderColor: groupColors[(getStudent((row-1)*6+col-1).groupId-1)%groupColors.length], borderWidth: '3px', borderStyle: 'solid' } : {}"
          >
            <template v-if="getStudent((row-1)*6+col-1).username">
              <span>{{ getStudent((row-1)*6+col-1).username }}</span>
              <span v-if="getStudent((row-1)*6+col-1).groupLeader === 1"> 👑</span>
            </template>
          </button>
        </div>
      </div>
      <div class="seatmap-side">
        <div v-for="row in rightRows" :key="'R'+row" class="seat-row">
          <button
            v-for="col in 6"
            :key="'R'+row+'-'+col"
            class="seat-btn"
            draggable="true"
            @dragstart="handleDragStart(60+(row-1)*6+col-1)"
            @dragover.prevent
            @drop="handleDrop(60+(row-1)*6+col-1)"
            :style="getStudent(60+(row-1)*6+col-1).groupId ? { borderColor: groupColors[(getStudent(60+(row-1)*6+col-1).groupId-1)%groupColors.length], borderWidth: '3px', borderStyle: 'solid' } : {}"
          >
            <template v-if="getStudent(60+(row-1)*6+col-1).username">
              <span>{{ getStudent(60+(row-1)*6+col-1).username }}</span>
              <span v-if="getStudent(60+(row-1)*6+col-1).groupLeader === 1"> 👑</span>
            </template>
          </button>
        </div>
      </div>
    </div>
    <div class="platform-box" @click="showSaveDialog = true">讲台</div>
    <el-dialog v-model="showSaveDialog" title="保存座次" width="350px" :close-on-click-modal="false">
      <div style="text-align:center;">是否要保存当前座次？</div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showSaveDialog = false">取消</el-button>
          <el-button type="primary" @click="saveSeatMap" :loading="saving">保存</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import HeaderBar from '@/components/HeaderBar.vue';
import { getUserList } from '@/api/index.js';
import { ElMessage } from 'element-plus';
import axios from 'axios';
export default {
  name: 'SeatMap',
  components: { HeaderBar },
  data() {
    return {
      students: [],
      leftRows: 10,
      rightRows: 10,
      dragIndex: null,
      showSaveDialog: false,
      saving: false,
      groupColors: [
        '#e53935', // 红
        '#8e24aa', // 紫
        '#3949ab', // 蓝
        '#039be5', // 天蓝
        '#00897b', // 青
        '#43a047', // 绿
        '#fbc02d', // 黄
        '#fb8c00', // 橙
        '#6d4c41', // 棕
        '#d81b60', // 粉
        '#1e88e5', // 深蓝
        '#00acc1', // 湖蓝
        '#7cb342', // 浅绿
        '#f4511e', // 深橙
        '#757575', // 灰
        '#c62828', // 深红
        '#ad1457', // 深粉
        '#283593', // 靛蓝
        '#00838f', // 深青
        '#2e7d32'  // 深绿
      ],
    };
  },
  async mounted() {
    await this.loadStudents();
  },
  methods: {
    async loadStudents() {
      const res = await getUserList();
      if (res.code === '000000') {
        // seatNo>0的学生按seatNo排到对应座位
        const seats = Array(120).fill(null);
        const noSeat = [];
        res.data.forEach(s => {
          if (s.seatNo && s.seatNo > 0 && s.seatNo <= 120) {
            seats[s.seatNo - 1] = s;
          } else {
            noSeat.push(s);
          }
        });
        // seatNo=0或未定义的学生顺序补到空位
        let idx = 0;
        for (let i = 0; i < seats.length; i++) {
          if (!seats[i] && idx < noSeat.length) {
            seats[i] = noSeat[idx];
            seats[i].seatNo = i + 1;
            idx++;
          }
        }
        this.students = seats;
      }
    },
    getStudentName(idx) {
      if (this.students[idx]) {
        return this.students[idx].username;
      }
      return '';
    },
    getStudent(idx) {
      return this.students[idx] || {};
    },
    handleDragStart(idx) {
      this.dragIndex = idx;
    },
    handleDrop(idx) {
      if (this.dragIndex === null || this.dragIndex === idx) return;
      // 交换学生位置
      const temp = this.students[idx];
      this.students[idx] = this.students[this.dragIndex];
      this.students[this.dragIndex] = temp;
      // 更新seatNo属性
      if (this.students[idx]) this.students[idx].seatNo = idx + 1;
      if (this.students[this.dragIndex]) this.students[this.dragIndex].seatNo = this.dragIndex + 1;
      // 输出信息
      const student = this.students[idx];
      if (student) {
        this.$message && this.$message.success
          ? this.$message.success(`${student.username} ${idx + 1}号`)
          : console.log(`${student.username} ${idx + 1}号`);
      }
      this.dragIndex = null;
    },
    async saveSeatMap() {
      this.saving = true;
      try {
        // 只提交有学生的座位
        const data = this.students
          .filter(s => s && s.userId)
          .map(s => ({ userId: s.userId, seatNo: s.seatNo }));
        const res = await axios.post('/api/user/updateSeatNo', data);
        if (res.data && res.data.code === '000000') {
          ElMessage.success('保存成功');
          this.showSaveDialog = false;
          await this.loadStudents();
        } else {
          throw new Error(res.data.msg || '保存失败');
        }
      } catch (e) {
        ElMessage.error('保存失败: ' + (e.response?.data?.msg || e.message));
      } finally {
        this.saving = false;
      }
    },
  }
};
</script>

<style scoped>
.seatmap-container {
  padding: 32px;
  background: #f4f8fb;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.seatmap-main {
  display: flex;
  justify-content: center;
  gap: 60px;
  margin: 40px 0 0 0;
}
.seatmap-side {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.seat-row {
  display: flex;
  gap: 12px;
}
.seat-btn {
  width: 90px;
  height: 40px;
  background: #4fa3f7;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;
}
.seat-btn:empty {
  background: #e0e0e0;
  cursor: default;
}
.seat-btn[draggable="true"] {
  cursor: grab;
}
.seat-btn[draggable="true"]:active {
  cursor: grabbing;
}
.platform-box {
  margin: 48px auto 0 auto;
  padding: 14px 60px;
  border: 2px solid #4fa3f7;
  border-radius: 12px;
  background: #fff;
  color: #4fa3f7;
  font-size: 1.3rem;
  font-weight: bold;
  text-align: center;
  box-shadow: 0 2px 8px #b3c6e0;
}
@media (max-width: 900px) {
  .seatmap-main {
    flex-direction: column;
    gap: 24px;
    align-items: center;
  }
  .platform-box {
    padding: 10px 30px;
    font-size: 1.1rem;
  }
}
@media (max-width: 600px) {
  .seatmap-container {
    padding: 6px;
    min-height: unset;
  }
  .seatmap-main {
    flex-direction: column;
    gap: 8px;
    margin: 10px 0 0 0;
    align-items: center;
  }
  .seatmap-side {
    gap: 2px;
  }
  .seat-row {
    gap: 2px;
  }
  .seat-btn {
    width: 32px;
    height: 22px;
    font-size: 0.7rem;
    padding: 0;
  }
  .platform-box {
    padding: 6px 10px;
    font-size: 0.9rem;
    margin: 16px auto 0 auto;
  }
  .el-dialog {
    width: 98vw !important;
    min-width: unset !important;
    max-width: 100vw !important;
    margin: 0 !important;
    left: 0 !important;
  }
}
</style> 